import React, {useState} from 'react';
import {Confirm, Popup} from 'semantic-ui-react';
import {CustomDropDown} from '../../../../manageOrders/components/internalCommons/customDropDown';

const generateJson = (data, key, previousValue, newValue, filters) => {
  return {
    'order_number': data.orderNumber,
    'line': data.line,
    'chassis': data.chassis,
    'previous_value': previousValue,
    'new_value': newValue,
    'field': key,
    'filters': {...filters},
  };
};

export const tableHeaderTransitWithProps = ({
  data,
  lists,
  fetchUpdateModelsLine,
  filters,
  isUserTde,
  dealerId,
}) => {
  const dealerHiddenColums = ['observations', 'cif', 'stateText'];
  const columns = [
    {
      'Header': () => <span className="header-title">LÍNEA</span>,
      'title': 'LÍNEA',
      'accessor': 'line',
    },
    {
      'Header': () => <span className="header-title">PEDIDO</span>,
      'title': 'PEDIDO',
      'accessor': 'orderNumber',
    },
    {
      'Header': () => <span className="header-title">SFX</span>,
      'title': 'SFX',
      'accessor': 'sfx',
    },
    {
      'Header': () => <span className="header-title">MODELO (KATASHIKI)</span>,
      'title': 'MODELO (KATASHIKI',
      'accessor': 'master',
    },
    {
      'Header': () => <span className="header-title">DESCRIPCIÓN</span>,
      'title': 'DESCRIPCIÓN',
      'accessor': 'description',
    },
    {
      'Header': () => <span className="header-title">COLOR EXTERNO</span>,
      'title': 'COLOR EXTERNO',
      'accessor': 'externalColor',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO EXTERNO</span>,
      'title': 'CÓDIGO EXTERNO',
      'accessor': 'externalColorId',
    },
    {
      'Header': () => <span className="header-title">COLOR INTERNO</span>,
      'title': 'COLOR INTERNO',
      'accessor': 'internalColor',
    },
    {
      'Header': () => <span className="header-title">CÓDIGO INTERNO</span>,
      'title': 'CÓDIGO INTERNO',
      'accessor': 'internalColorId',
    },
    {
      'Header': () => <span className="header-title">CHASIS</span>,
      'title': 'CHASIS',
      'accessor': 'chassis',
    },
    {
      'Header': () => <span className="header-title">MOTOR</span>,
      'title': 'MOTOR',
      'accessor': 'motor',
    },
    {
      'Header': () => <span className="header-title">RAMV</span>,
      'title': 'RAMV',
      'accessor': 'ranmv',
    },
    {
      'Header': () => <span className="header-title">AÑO MODELO</span>,
      'title': 'AÑO MODELO',
      'accessor': 'yearModel',
    },
    {
      'Header': () => <span className="header-title">ETD</span>,
      'title': 'ETD',
      'accessor': 'dateOfShipmentText',
    },
    {
      'Header': () => <span className="header-title">ETA</span>,
      'accessor': 'modificationDate',
      'title': 'ETA',
      'Cell': ({row}) => <>{row.original.modificationDate?.substring(0, 10) || ''}</>,
    },
    {
      'Header': () => <span className="header-title">EMBARQUE</span>,
      'title': 'EMBARQUE',
      'accessor': 'shipmentText',
    },
    {
      'Header': () => <span className="header-title">FACTURA ORIGEN</span>,
      'title': 'FACTURA ORIGEN',
      'accessor': 'invoiceNumber',
    },
    {
      'Header': () => <span className="header-title">UBICACIÓN</span>,
      'title': 'UBICACIÓN',
      'accessor': 'locationText',
    },
    {
      'Header': () => <span className="header-title">ASIGNADO A</span>,
      'title': 'ASIGNADO A',
      'accessor': 'dealerName',
      'Cell': ({row}) => {
        const [selectedDealerId, setselectedDealerId] = useState(row.original.dealerId);
        const [openConfirm, setOpenConfirm] = useState(false);

        const currentValue = row.original.dealerId;
        const handleDropdown = (data, field, newValue) => {
          const dataForQuery = generateJson(data, field, currentValue, newValue, filters);
          fetchUpdateModelsLine(dataForQuery);
        };

        const handleConfirm = () => {
          const dataForQuery = generateJson(
            row.original,
            'dealer_id',
            currentValue,
            selectedDealerId,
            filters
          );
          fetchUpdateModelsLine(dataForQuery);
          setOpenConfirm(false);
        };

        if (!isUserTde) {
          return <div className={'selector-medium-size'}>{row.original.dealerName}</div>;
        }
        if (row.original.destiny === 'NL') {
          return (
            <CustomDropDown
              placeholder="Seleccionar dealer"
              className={'selector-medium-size'}
              value={row.original.dealerId}
              onChange={(e, {value}) =>
                handleDropdown(
                  row.original,
                  'dealer_id',
                  value
                )
              }
              options={lists.listDealersAll}
            />
          );
        }
        return (
          <>
            <CustomDropDown
              placeholder="Seleccionar dealer"
              className={'selector-medium-size'}
              value={row.original.dealerId}
              onChange={(e, {value}) => {
                setselectedDealerId(value);
                setOpenConfirm(true);
              }
              }
              options={lists.listDealersAll}
            />
            <Confirm
              size='mini'
              header="¿Seguro que desea continuar?"
              content='El vehículo que intenta modificar pertenece a Inventario Flotante'
              cancelButton="Cancelar"
              confirmButton="Continuar"
              open={openConfirm}
              onCancel={() => setOpenConfirm(false)}
              onConfirm={handleConfirm}
            />
          </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">OBSERVACIONES</span>,
      'title': 'OBSERVACIONES',
      'accessor': 'observations',
      'Cell': ({row}) => (
        <>
          <Popup
            trigger={
              <div className="dot">
                {row.original?.observations?.length || 0}
              </div>
            }
            position="top center"
            size="small"
            className="observations-popup"
            disabled={!row?.original?.observations?.length}
            inverted
          >
            <Popup.Header>Modificaciones en "Asignado A"</Popup.Header>
            <Popup.Content style={{'fontSize': '9px'}}>
              <table>
                {row?.original?.observations?.map((observation, index) => (
                  <tr>
                    <th>{observation.arrivalDate}:</th>
                    <th>{observation.dealerNameOld}</th>
                    <th>&rarr;</th>
                    <th>{observation.dealerNameNew}</th>
                  </tr>
                ))}
              </table>
            </Popup.Content>
          </Popup>
        </>
      ),
    },
    {
      'Header': () => <span className="header-title">IMPORTADOR</span>,
      'title': 'IMPORTADOR',
      'accessor': 'importerName',
    },
    {
      'Header': () => <span className="header-title">CLIENTE</span>,
      'title': 'CLIENTE',
      'accessor': 'clientName',
      'Cell': ({row}) => {
        if (isUserTde || row.original.dealerId === dealerId) {
          return (
            <>{row.original.clientName}</>
          );
        }
        return (
          <> </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">RUC CLIENTE</span>,
      'title': 'RUC CLIENTE',
      'accessor': 'clientId',
      'Cell': ({row}) => {
        if (isUserTde || row.original.dealerId === dealerId) {
          return (
            <>{row.original.clientId}</>
          );
        }
        return (
          <> </>
        );
      },
    },
    {
      'Header': () => <span className="header-title">DESTINO</span>,
      'title': 'DESTINO',
      'accessor': 'destinyText',
    },
    {
      'Header': () => <span className="header-title">C&F</span>,
      'title': 'C&F',
      'accessor': 'cif',
    },
    {
      'Header': () => <span className="header-title">ESTADO</span>,
      'title': 'ESTADO',
      'accessor': 'stateText',
    },
  ];
  if (isUserTde) {
    return columns;
  }
  return columns.filter((column) => !dealerHiddenColums.includes(column.accessor));
};
